import * as React from "react";

import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import * as Enums from "@tunnel-enums/index";
import * as Utils from "@Cyclope-Utils/index";
import * as Paths from "@tunnel-enums/index";
import * as Lodash from "lodash";
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
import * as Styled from "@tunnel-components/@sharded/@styled/cart";
import DatePicker from "@tunnel-components/@sharded/@widgets/dataPicker";
import SelectGrid from "@tunnel-components/@sharded/@widgets/select";
import * as i18next from "i18next";
import * as cx from "classnames";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    IncidentTypeList,
    onEndDateChange,
    onStartDateChange,
    selectedOptionsIncident,
    error,
    simulation,
    loading,
    btnloading,
    errorserver,
    noIncidents,
    onChange,
    onGetValue,
    onSubmit,
    cameraIderror,
    typeincidenterror,
    selectedOptions,
  } = props;
  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.SIMULATORCREATED,
  ]);
  //

  /**
   * @description : retourne un boolean ( )
   * @const
   * @name siteLoading
   * @type { boolean  }
   */
  const siteLoading: boolean =
    !Lodash.isUndefined(IncidentTypeList) &&
    !Lodash.isEmpty(IncidentTypeList) &&
    !Lodash.isNull(IncidentTypeList);

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid
      snackbar={simulation}
      someTextSuccees={i18next.t("la simulation a bien ete creee")}
      loading={loading}
      btnloading={btnloading}
      empty={noIncidents}
      error={errorserver}
    >
      {siteLoading && (
        <section className="tunnel-site animated fadeIn">
          <BreadCrumb
            iconSupervision={true}
            links1={Paths.PathsNamesEnums.SIMULATOR}
            title={i18next.t("supervision")}
            breadText1={i18next.t("simulation")}
          />
          <div className="contentAllSiteWithoutOnglet">
            <section className="columnsWithoutOnglet">
              <section className="content-wrapper">
                <section className="with--columns" id="columns">
                  <div className="formSimulator">
                    <BoxGrid
                      title={i18next.t("CREER UNE SIMULATION")}
                      classNames="boderShadow"
                      onSubmit={!simulation ? onSubmit : undefined}
                      error={!authorization}
                      BtnTextSpan={i18next.t("enregistrer")}
                    >
                      <Styled.CartContainer>
                        <div className="extractionInfo left">
                          <div className={cx("titleAction")}>
                            <h2>{i18next.t("cameras et incidents")} : </h2>
                            <div className="blockDatePicker ">
                              <SelectGrid
                                error={cameraIderror}
                                camera={true}
                                selectedOptions={selectedOptions}
                                onGetIdentifiantItem={onGetValue}
                                placeholder={i18next.t("rechercher une camera")}
                              />
                            </div>
                            <div className="blockDatePicker ">
                              <SelectGrid
                                error={typeincidenterror}
                                incident={true}
                                selectedOptions={selectedOptionsIncident}
                                onGetIdentifiantItem={onChange}
                                placeholder={i18next.t(
                                  "rechercher un incident ..."
                                )}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="extractionInfo left">
                          <div className={cx("titleAction")}>
                            <h2> {i18next.t("plage horaire")} : </h2>
                            <div className="blockDatePicker ">
                              <DatePicker
                                placeholder={i18next.t("date de debut")}
                                error={error}
                                onChangeSelected={onStartDateChange}
                              />
                            </div>
                            <div className="blockDatePicker ">
                              {" "}
                              <DatePicker
                                placeholder={i18next.t("date de fin")}
                                error={error}
                                onChangeSelected={onEndDateChange}
                              />
                            </div>
                          </div>
                        </div>
                      </Styled.CartContainer>
                    </BoxGrid>
                  </div>
                </section>
              </section>
            </section>
          </div>
        </section>
      )}
    </LayoutGrid>
  );
};

/** Valeurs par défaut des props */
Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  IncidentTypeList?: any;
  onEndDateChange?: any;
  selectedValueIncident?: any;
  onChange?: any;
  startDate?: any;
  endDate?: any;
  onStartDateChange?: any;
  error?: any;
  simulation?: any;
  loading?: any;
  data?: any;
  btnloading?: any;
  errorserver?: any;
  noIncidents?: any;
  onSubmit?: any;
  cameraIderror?: any;
  typeincidenterror?: any;
  selectedValue?: any;
  onGetValue?: any;
  onSearchValue?: any;
  selectedOptions?: any;
  onSearchIncident?: any;
  selectedOptionsIncident?: any;
}
/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/simulator/home/component.tsx